import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { AuthTokenService } from '../auth-token.service'
import { HeliosAuthModule } from '../auth.module'
import { MockAuthTokenService } from './mock-auth-token.service'

/**
 * Mocked version of `HeliosAuthModule` for use in testing.
 */
@NgModule({
  imports: [CommonModule, HeliosAuthModule],
  providers: [{ provide: AuthTokenService, useClass: MockAuthTokenService }],
})
export class MockHeliosAuthModule {}
